import React from "react";
import { Navigate } from "react-router-dom";
import { getLocalStorageItem } from "../Helper/helper";

const PrivateAdminRoute = ({ children }) => {
	const userDetails = getLocalStorageItem("ORDER_USER_DETAILS");
	const role = userDetails?.role || localStorage.getItem("ORDER_USER_ROLE");
	const AUTH_TOKEN = getLocalStorageItem("ORDER_AUTH_TOKEN");

	if (AUTH_TOKEN) {
		if (role == 5 || role == "5" || role == 1 || role == "1") {
			return children;
		} else {
			return <Navigate to="/access-denied" />;
		}
	} else {
		return <Navigate to="/login" />;
	}
};

export default PrivateAdminRoute;